// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo[data-v-9f624482]{align-items:center;cursor:pointer;display:flex;flex-direction:column;text-decoration:none}.logo-text[data-v-9f624482]{bottom:10px;color:#555;font-size:13px;font-weight:400;justify-content:space-between;letter-spacing:-.18px;line-height:18px;margin:0;text-align:center}.logo-image[data-v-9f624482]{filter:blur(0);margin-right:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
